var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "default-modal",
    {
      attrs: {
        name: "settle-project",
        title: _vm.$t("settle_project"),
        actionLabel: _vm.$t("settle_hours"),
        successHandler: _vm.handleSettle
      },
      model: {
        value: _vm.modalOpened,
        callback: function($$v) {
          _vm.modalOpened = $$v
        },
        expression: "modalOpened"
      }
    },
    [
      _c(
        "template",
        { slot: "content" },
        [
          _c("p", [_vm._v(_vm._s(_vm.$t("settle_project_modal_grouping")))]),
          _c(
            "q-list",
            { staticClass: "no-border", attrs: { link: "" } },
            [
              _vm.showFixedOption
                ? _c(
                    "q-item",
                    { attrs: { tag: "label" } },
                    [
                      _c(
                        "q-item-side",
                        [
                          _c("q-radio", {
                            attrs: { val: "fixed" },
                            model: {
                              value: _vm.formData.grouping,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "grouping", $$v)
                              },
                              expression: "formData.grouping"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "q-item-main",
                        [
                          _c("q-item-tile", { attrs: { title: "" } }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("settle_project_modal_grouping_fixed")
                              )
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "q-item",
                { attrs: { tag: "label" } },
                [
                  _c(
                    "q-item-side",
                    [
                      _c("q-radio", {
                        attrs: { val: "summary" },
                        model: {
                          value: _vm.formData.grouping,
                          callback: function($$v) {
                            _vm.$set(_vm.formData, "grouping", $$v)
                          },
                          expression: "formData.grouping"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "q-item-main",
                    [
                      _c("q-item-tile", { attrs: { title: "" } }, [
                        _vm._v(
                          _vm._s(_vm.$t("settle_project_modal_grouping_all"))
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "q-item",
                { attrs: { tag: "label" } },
                [
                  _c(
                    "q-item-side",
                    [
                      _c("q-radio", {
                        attrs: { val: "description" },
                        model: {
                          value: _vm.formData.grouping,
                          callback: function($$v) {
                            _vm.$set(_vm.formData, "grouping", $$v)
                          },
                          expression: "formData.grouping"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "q-item-main",
                    [
                      _c("q-item-tile", { attrs: { label: "" } }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("settle_project_modal_grouping_activity")
                          )
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "q-item",
                { attrs: { tag: "label" } },
                [
                  _c(
                    "q-item-side",
                    [
                      _c("q-radio", {
                        attrs: { val: "individual" },
                        model: {
                          value: _vm.formData.grouping,
                          callback: function($$v) {
                            _vm.$set(_vm.formData, "grouping", $$v)
                          },
                          expression: "formData.grouping"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "q-item-main",
                    [
                      _c("q-item-tile", { attrs: { label: "" } }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("settle_project_modal_grouping_individual")
                          )
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "q-field",
            [
              _c("q-select", {
                attrs: {
                  options: _vm.roundingOptions,
                  name: "rounding",
                  placeholder: _vm.$t("settle_project_modal_rounding"),
                  "float-label": _vm.$t("settle_project_modal_rounding")
                },
                model: {
                  value: _vm.formData.rounding,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "rounding", $$v)
                  },
                  expression: "formData.rounding"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }